import MyAcvServiceClient from '@/api/MyAcvServiceClient';
import featureFlagSlugs from '@/constants/featureFlagSlugs';

export const mutations = {
  setInvoiceSummaryBalance(state, data) {
    state.invoiceSummaryBalance = data;
  },
};

export const actions = {
  async getInvoiceSummaryBalance({
    commit,
  }) {
    try {
      const client = new MyAcvServiceClient();
      const { data: { data } } = await client.getSummaryBalance();
      commit('setInvoiceSummaryBalance', data);
      return data;
    } catch (error) {
      const errorMessage = error.message || 'Failed to retrieve summary balance';
      throw new Error(errorMessage);
    }
  },
};

export const getters = {
  invoiceSummaryBalance: (state) => state.invoiceSummaryBalance,
  isInvoicesMenuEnabled(state, localGetters, rootState) {
    return !!rootState.featureFlags.flags[featureFlagSlugs.myAcvShowBillingPage];
  },
};

export const state = {
  invoiceSummaryBalance: {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
